import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContentType, DialogFooterType, IconNames, CUIText } from '@dotcom/crown-ui';
import { USPSValidationDialogTypes } from './usps-validation-dialog-types';
import styles from './usps-validation-dialog.module.scss';

export const USPSValidationDialog = ({
  isOpen,
  onClose,
  title,
  message,
  onConfirm,
  children,
}: USPSValidationDialogTypes) => {
  const { t } = useTranslation();

  const handleClick = () => {
    onConfirm();
  };

  return (
    <Dialog
      type={DialogContentType.FeatureModal}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      dialogClassName={styles['usps-validation-dialog']}
      testId={'usps-validation-dialog'}
      accentIcon={IconNames.AddressBookBold}
      hasGrayBackground={false}
      footerType={DialogFooterType.SingleButton}
      actionButton={
        <Button testId={'dialog-confirm-button'} onClick={handleClick}>
          {t('addressConfirmation.confirmatonButtonLabel')}
        </Button>
      }
    >
      <header data-testid="usps-validation-dialog-header">
        <CUIText as="span" className={styles['description']}>
          {message}
        </CUIText>
      </header>

      <section data-testid="usps-validation-dialog-content">{children}</section>
    </Dialog>
  );
};
